import React, {useEffect, useState} from 'react';
import MapArea from './map/MapArea';
import Sidebar from './elements/Sidebar';
import { useDispatch, useSelector } from 'react-redux'
import {fetchAninhamentos, fetchAvistamentos, fetchAtaques, show_sidebar, hide_sidebar} from './redux/actions';
import {useHistory} from 'react-router';

function MainWindow() {
    const history=useHistory();
    const dispatch = useDispatch();
    const sidebarShowing = useSelector(state => state.sidebar.show);
    const [prevLoc, setPrevLoc] = useState("/")

    useEffect(() => {
        
        
        history.listen((loc, action) => {
 
            setPrevLoc(loc.pathname)
                if(window.innerWidth <=810 && action==='POP' && prevLoc === '/'){
                
                    
                        history.push('/');
                        
                        dispatch(show_sidebar());
                
            }
            // if(action==='POP'){
                
            //     dispatch(submission_clean())
            //     dispatch(upload_image_clean())
                
            // }


        });


        
       

        return history.unlisten
    }, []
      )

    useEffect(() => {
        dispatch(fetchAninhamentos())
        dispatch(fetchAvistamentos())
        dispatch(fetchAtaques())
    }, [])
      

    return(
        <div
        id='whole'
            style={{
            "position": "absolute",
            "width": "100vw",
            "height": "100vh"
            }
            }
        >

            <div>
                {sidebarShowing && window.innerWidth>810?<div
                    onClick={() => dispatch(hide_sidebar())}
                    style = {
                        {
                        width:'64px',
                        height:'48px',
                        position: 'absolute',
                        cursor:'pointer',
                        left: '10px',
                        top: '10px',
                        zIndex:'1700',
                        display: 'flex',
                        flexDirection:'column',
                        fontWeight:'bold',
                        alignContent: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#F7F9F9',
                        borderRadius: '2px',
                        
                        }
                        }
                        >
                    <div style={{display:'flex', justifyContent:'space-around'}}><img src='/app/map.png' alt="" style={{width:'32px', height:'32px'}}/></div>
                    <div style={{fontSize:'0.8em', display:'flex', justifyContent:'space-around'}}>Ver mapa</div>
                    </div>:null}
                   
            </div>
            
            {sidebarShowing ? <Sidebar/> :null}
                
            <MapArea />
            {/* <CookieConsent
                location='bottom'
                buttonText='Compreendi'
                cookieName='AutorizaCookies'
                declineButtonText='Não autorizo'
                style={{zIndex:5000}}
                expires={150}>Esta aplicação utiliza cookies para melhorar a experiência do utilizador e para agregar anonimamente estatísticas de utilização.  <Link to={'/pg/termos'}>Saber mais.</Link></CookieConsent>
            </>:<Loader
            type='TailSpin'
            color='#0094CF'
            height='200'
            width='200'
      />} */}
        </div>

        
        
    )
}

export default MainWindow;
